<template>
  <div>
    <h1 class="d-flex align-items-center">
      <span class="icon mr-2 icon-produkte_statistik" aria-hidden="true"></span>
      {{ $t('views.dailyReport.title') }}
    </h1>

    <link-back :to="'/reports'" i18nMessage="common.backToOverview" />

    <h2 class="mt-2">{{ room.name }}</h2>

    <control-date
      i18nLabel="views.dailyReport.date"
      v-model="date"
      :validation="v$.date"
      @update:modelValue="loadFromServer()"
      class="hide-in-print"
    />

    <loading-container :state="state" errorLinkTo="/reports">

      <div class="show-in-print"><strong>Datum: </strong> {{niceDate(date)}}</div>
      <div class="d-flex justify-content-end" v-if="tickets.length > 0"><button-print /></div>
      <result-list-tickets-daily :tickets="tickets" v-if="tickets.length > 0" />
      <feedback-message v-else :message="$t('views.dailyReport.noEntry')" />
    </loading-container>
  </div>
</template>

<script lang="ts">
import ControlDate from '@/components/controls/ControlDate.vue';
import FeedbackMessage from '@/components/feedback/FeedbackMessage.vue';
import ResultListTicketsDaily from '@/components/filterforms/ResultListTicketsDaily.vue';
import LinkBack from '@/components/interaction/LinkBack.vue';
import LoadingContainer from '@/components/structure/LoadingContainer.vue';
import { Room, Ticket } from '@/generated/openapi';
import LoadingMixin from '@/mixins/LoadingMixin';
import { adminService } from '@/services/adminService';
import { now } from '@/utils/dateTimeUtils';
import { validateAndFocusInvalid } from '@/utils/formUtils';
import { LoadingState } from '@/utils/loadingUtils';
import { urlParamString } from '@/utils/navigationUtils';
import { isDateString } from '@/utils/validationUtils';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { defineComponent } from 'vue';
import ButtonPrint from '@/components/interaction/ButtonPrint.vue';
import { formatDateString } from '@/utils/formatUtils';

export default defineComponent({
  name: 'DailyReport',
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      room: {} as Room,
      tickets: [] as Ticket[],
      date: now().toISODate()
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  validations() {
    return {
      date: {
        required,
        isDateString,
      }
    }
  },

  created() {
    const roomId = urlParamString(this.$route, 'id')
    adminService.getRoom(roomId).then(room => {
      this.room = room
      this.loadFromServer()
    }).catch(this.handleErrorWithI18nString)
  },
  methods: {
    loadFromServer() {
      validateAndFocusInvalid(this.v$, this.$el).then(() => {
        this.state = LoadingState.loading
        adminService.findDailyTickets(this.room.id, this.date)
          .then(tickets => {
            this.tickets = tickets.content || []
            this.state = LoadingState.success
          }).catch(this.handleErrorWithI18nString)
      })
    },
    niceDate(date: string){
      return formatDateString(date);
    }
  },
  components: {
    LoadingContainer,
    ControlDate,
    LinkBack,
    ResultListTicketsDaily,
    FeedbackMessage,
    ButtonPrint
  }
});
</script>
